import { Head } from "@inertiajs/react"
import PublicLayout from "@/components/PublicLayout"

const TITLE = "Session link expired | Sanctuary Therapy Centre"
const DESCRIPTION =
  "This video-session link is no longer valid. Session rooms expire automatically — ask your therapist for a fresh link."

export default function VideoSessionGone() {
  return (
    <>
      <Head title={TITLE}>
        <meta name="description" content={DESCRIPTION} />
        <meta property="og:title" content={TITLE} />
        <meta property="og:description" content={DESCRIPTION} />
        <meta name="robots" content="noindex, nofollow" />
      </Head>
      <PublicLayout>
        <section className="bg-cream pt-32 pb-24">
          <div className="mx-auto max-w-2xl px-6 text-center lg:px-8">
            <h1>This session link is no longer valid</h1>
            <p className="mt-4 text-ink-muted">
              Session rooms expire automatically and can't be reopened. Please ask your therapist for a
              fresh link.
            </p>
            <p className="mt-8">
              <a href="/contact">Contact Sanctuary →</a>
            </p>
          </div>
        </section>
      </PublicLayout>
    </>
  )
}
